
import { CrudEditComponent } from './../../../shared/components/crud/edit/edit.component';
import { COMPETENCIAS_ACTIONS_DELETED, COMPETENCIAS_FIELDS_CONFIG, COMPETENCIAS_FIELDS_CONFIG_CREATE, COMPETENCIAS_FIELDS_SUPERIOR_CONFIG_CREATE } from './../../../constants/competencias.constants';
import { Table } from './../../../shared/components/table/table.component';
import { MateriaInterface } from './../../../models/materia.model';
import { MateriasService } from './../../../core/materias.service';
import { BasePageComponent } from './../../../shared/components/base-page/base-page.component';
import { ChangeDetectorRef, Component, ElementRef, inject, Injectable, Input, OnChanges, signal, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { CompetenciasService } from '../../../core/competencia.service';
import { ActivatedRoute } from '@angular/router';
import { COMPETENCIAS_ACTIONS, COMPETENCIAS_COLUMN_NAMES } from '../../../constants/competencias.constants';
import { defaultPaginateSelects, PaginateData, PaginateOptions } from '../../../utils/paginate.utils';
import { Titledescription } from "../../../shared/components/titledescription/titledescription.component";
import { NivelService } from '../../../core/nivel.service';
import { BaseSelectService } from '../../../core/BaseSelect.service';
import { TituloService } from '../../../core/titulo.service';
import { TituloInterface } from '../../../models/titulo.model';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CardComponent } from '../../../shared/components/card/card.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { Button } from '../../../shared/components/button/button.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { CompetenciaInterface } from '../../../models/competencia.model';
import { MATERIAS_ACTIONS, MATERIAS_ADDED_ACTIONS,MATERIAS_COLUMN_NAMES_COMPACT } from '../../../constants/materias.constants';
import { MatListModule } from '@angular/material/list';
import { Form } from '../../../shared/components/form/form.component';
import { CaracterService } from '../../../core/caracter.service';
import { ModalidadService } from '../../../core/modalidad.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertComponent } from '../../../shared/components/alert/alert.component';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FieldValueEmit } from '../../../constants/form.constants';
import { MatSelectModule } from '@angular/material/select';
import { CrudViewComponent } from '../../../shared/components/crud/view/view';
import { CompetenciasList } from '../../competencias/list/competencias-list.component';
import { CompetenciasEditComponent } from '../../competencias/edit/edit.component';

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-asignar-competencia',
  imports: [BasePageComponent,
    Table,
    Titledescription,
    MatCardModule,
    MatButtonModule,
    CardComponent,
    MatExpansionModule,
    MatDividerModule,
    MatGridListModule,
    MatListModule,
    Form,
    Button,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    CrudViewComponent,
    CompetenciasEditComponent
  ],
  templateUrl: './competencias.component.html',
  styleUrl: './competencias.component.scss',
})
export class TituloCompetenciasComponent {
    @ViewChild('expansionPanel', { read: ElementRef }) expansionPanelRef!: ElementRef;
  // Convierte cualquier objeto a {[key:string]:any}
  castToObject(data: any): { [key: string]: any } {
    if (!data || typeof data !== 'object') return {};
    return { ...data };
  }

  //services that i use
  apiService = inject(CompetenciasService);
  nivelService = inject(NivelService);
  tituloService = inject(TituloService);
  materiaService = inject(MateriasService);
  caracterService = inject(CaracterService);
  modalidadService = inject(ModalidadService);
  competenciaService = inject(CompetenciasService);

  // data necesary
  @Input() nivelSelected!: number;
  nivelSelectedInEdit!: number;
  dataSelectNiveles: any[] = [];
  dataSelectCaracter: any[] = [];
  dataSelectModalidades: any[] = [];
  dataTitulo !: TituloInterface;
  dataMaterias!: PaginateData<MateriaInterface>;
  dataAddMaterias: PaginateData<MateriaInterface> = { data: [], total_items: 0 };

  // variable for table
  dataFetch !: PaginateData<CompetenciaInterface>
  titulo_id !: number
  columnNamesCompetencias = COMPETENCIAS_COLUMN_NAMES;
  fieldsAddCompetencias = COMPETENCIAS_FIELDS_CONFIG_CREATE;
  fieldsAddCompetenciasSuperior = COMPETENCIAS_FIELDS_SUPERIOR_CONFIG_CREATE;
  fieldsAddCompetenciasModal = COMPETENCIAS_FIELDS_CONFIG;
  columnNamesMaterias = MATERIAS_COLUMN_NAMES_COMPACT;
  actions = COMPETENCIAS_ACTIONS
  actionsDeletedItems = COMPETENCIAS_ACTIONS_DELETED
  materiasAddedActions =  MATERIAS_ADDED_ACTIONS
  materiasAction = MATERIAS_ACTIONS
  errorMessage!: string;
  spinner : boolean = false;
  modalidad_selected!: number;
  competencia_id !: number;
  competenciaDetail !: CompetenciaInterface;
  templateView: boolean = false;
  isLoadingPDF = signal(false);

  // Guarda los parámetros actuales de paginación y filtros
  currentPaginateOptions: PaginateOptions = { skip: 0, take: 50 };
    async downloadCompetenciasNivelPDF() {
      this.isLoadingPDF.set(true);
      try {
        const jsPDF = await import('jspdf');
        // @ts-ignore
        const autoTable = (await import('jspdf-autotable')).default || (await import('jspdf-autotable'));
        const doc = new jsPDF.jsPDF();
        const nivel = this.dataSelectNiveles.find(n => n.value === this.nivelSelected);
        const titulo = this.dataTitulo;
        const competencias = this.dataFetch?.data?.filter((c: any) => c.nivel_id === this.nivelSelected) || [];

        // Definir columnas requeridas
        const columns = [
          { key: 'materia', label: 'Materia' },
          { key: 'modalidad', label: 'Modalidad' },
          { key: 'caracter', label: 'Carácter' }
        ];
        // Agregar columna Título Concurrente si existe al menos una competencia con ese dato
        const hasTituloConcurrente = competencias.some((c: any) => c.tituloConcurrente && c.tituloConcurrente.descripcion);
        if (hasTituloConcurrente) {
          columns.push({ key: 'tituloConcurrente', label: 'Título Concurrente' });
        }

        // Encabezados de tabla
        const head = [columns.map(col => col.label)];
        // Filas de tabla
        const body = competencias.map((comp: any) => {
          const row = [
            comp.materia?.descripcion || '',
            comp.modalidad?.descripcion || '',
            comp.caracter?.descripcion || ''
          ];
          if (hasTituloConcurrente) {
            row.push(comp.tituloConcurrente?.descripcion || '');
          }
          return row;
        });

        // Título centrado y negrita
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(16);
        doc.text(titulo?.descripcion || 'Título', doc.internal.pageSize.getWidth() / 2, 20, { align: 'center' });

        // Subtítulo nivel centrado y negrita
        doc.setFontSize(12);
        doc.text(`Nivel: ${nivel?.label || ''}`, doc.internal.pageSize.getWidth() / 2, 30, { align: 'center' });

        // Tabla
        autoTable(doc, {
          head: head,
          body: body,
          startY: 40,
          styles: { fontSize: 10, cellPadding: 2, overflow: 'linebreak' },
          headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' },
          margin: { left: 10, right: 10 },
          theme: 'grid',
          rowPageBreak: 'avoid'
        });

        doc.save(`competencias_nivel_${nivel?.label || this.nivelSelected}.pdf`);
      } finally {
        this.isLoadingPDF.set(false);
      }
    }
  // variable for pagination
  totalItems!: number;
  totalItemsAddMaterias!: number;
  skip: number = 0;
  take: number = 50;

  readonly panelOpenState = signal(false);

  // injection by property
  private activatedRoute = inject(ActivatedRoute);
  private selectService = inject(BaseSelectService<number>);
  private alert = inject(AlertComponent);
  @ViewChild('materiasToAdd') tableMateriasToAdd!: Table<MateriaInterface>
  @ViewChild('materiasAdded') tableMateriasAdded!: Table<MateriaInterface>
  @ViewChild('form') form!: Form
  @ViewChild(CrudEditComponent) crudEditComponent!: CrudEditComponent<any>;
  @ViewChild('modalEditCompetencia') modalEditCompetencia!: CompetenciasEditComponent;

  constructor(private _snackBar: MatSnackBar,private cdr: ChangeDetectorRef) { }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000, // Optional: duration in milliseconds
    });
  }
  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.titulo_id = params['id'];
      this.tituloService.getById(this.titulo_id).subscribe((data) => {
        this.dataTitulo = <TituloInterface>data;
      })
    });
    this.getNiveles();

    this.currentPaginateOptions = { skip: this.skip, take: this.take };
    this.fetchData(this.currentPaginateOptions);
    this.getAllSelects();
    // this.getModalidades();
    // this.getTitulos();
    this.getMaterias({ skip: this.skip, take: this.take });
  }
  fetchData = (data: PaginateOptions , ignoreCache?:boolean) => {
    // data.filter_field = 'nivel_id';
    // data.filter_value = this.nivelSelected;
    let realIgnoreCache = ignoreCache;
    if ((data as any).ignoreCache) {
      realIgnoreCache = true;
      delete (data as any).ignoreCache;
    }
    data.mainFilterField = "nivel_id";
    this.take = data.take;
    // Actualiza los parámetros actuales
    this.currentPaginateOptions = { ...data };
    return this.apiService.getByTitulo(data, this.titulo_id, true).subscribe(data => {
      this.dataFetch = data;
      this.totalItems = this.dataFetch.total_items;
    });
  }
  getNiveles() {
    this.nivelService.getAllForSelect({ skip: this.skip, take: this.take }).subscribe((data) => {
      this.dataSelectNiveles = data;
    })
  }
  getMaterias(data: PaginateOptions, ignoreCache: boolean = false) {
    data.mainFilterField = "nivel_id";
    this.take = data.take;
    this.materiaService.getByModalidad(this.modalidad_selected, data, ignoreCache).subscribe((data) => {
      // Filtrar nulos en el array de materias
      // Filtrar materias que no estén ya asignadas al título
      let materiasAsignadasIds: number[] = [];
      if (this.dataFetch && Array.isArray(this.dataFetch.data)) {
        materiasAsignadasIds = this.dataFetch.data.map((c: any) => c.materia_id);
      }
      data.data = Array.isArray(data.data)
        ? data.data.filter(row => row != null && !materiasAsignadasIds.includes(row.id))
        : [];
      this.dataMaterias = data;
      this.totalItemsAddMaterias = this.dataMaterias.data.length;
      setTimeout(() => {
        this.spinner = false;
      }, 400); // 400ms de delay para asegurar visibilidad
    })
  }
  getAllSelects() {
    const serviceMap = new Map<any, any>([
      // [this.caracterService.constructor, this.caracterService],
      [this.modalidadService.constructor, this.modalidadService],
      [this.materiaService.constructor, this.materiaService],
      [this.nivelService.constructor, this.nivelService],
      [this.tituloService.constructor, this.tituloService],
      [this.caracterService.constructor, this.caracterService]
    ]);
    Object.entries(this.fieldsAddCompetenciasConfig).forEach(([fieldKey, field]) => {
      if (field.type === 'select' && field.serviceForSelect) {
        const serviceInstance = serviceMap.get(field.serviceForSelect);
        if (serviceInstance && typeof serviceInstance.getAllForSelect === 'function') {
          serviceInstance.getAllForSelect().subscribe((data: any) => {
            this.fieldsAddCompetenciasConfig[fieldKey].options = data;
          });
        }
      }
    });
    Object.entries(this.fieldsAddCompetenciasModal).forEach(([fieldKey, field]) => {
      if (field.type === 'select' && field.serviceForSelect) {
        const serviceInstance = serviceMap.get(field.serviceForSelect);
        if (serviceInstance && typeof serviceInstance.getAllForSelect === 'function') {
          serviceInstance.getAllForSelect().subscribe((data: any) => {
            this.fieldsAddCompetenciasModal[fieldKey].options = data;
          });
        }
      }
    });
  }
  getModalidades() {
    // Usar una copia para no modificar el objeto por defecto global
    const paginateOptions = { ...defaultPaginateSelects, mainFilterField: "nivel_id", mainValueToFilter: this.nivelSelected };
    this.modalidadService.getAllForSelect(paginateOptions).subscribe((data) => {
      // Filtrar modalidades por el nivel seleccionado
      let filtered = data;
      this.fieldsAddCompetencias['modalidad_id'].options = filtered;
    });
  }
  getCaracteres() {
    // Usar una copia para no modificar el objeto por defecto global
    const paginateOptions = { ...defaultPaginateSelects, mainFilterField: "nivel_id", mainValueToFilter: this.nivelSelected };
    this.caracterService.getAllForSelect(paginateOptions).subscribe((data) => {
      // Filtrar caracteres por el nivel seleccionado
      let filtered = data;
      this.fieldsAddCompetenciasConfig['caracter_id'].options = filtered;
    });
  }
  selectValueNivel(value: number) {
    this.nivelSelected = value;
    this.selectService.setValue(value)
    this.dataMaterias = { data: [], total_items: 0 };
    if (this.form) {
      this.form.reset();
    }
    if(this.nivelSelected == 0 ){
      this.currentPaginateOptions = { skip: this.skip, take: this.take };
      this.fetchData(this.currentPaginateOptions);
    }else{
      this.currentPaginateOptions = { skip: this.skip, take: this.take, mainFilterField:'nivel_id', mainValueToFilter:this.nivelSelected };
      this.fetchData(this.currentPaginateOptions);
      this.getModalidades();
      this.getCaracteres();
    }
  }
  getClickedRows(data: PaginateData<MateriaInterface>) {
    this.dataAddMaterias = {
      data: [...data.data],
      total_items: data.data.length
    };
  }
  clearAllMateriasAdded() {
    this.tableMateriasToAdd.clearAllSelectRow();
  }
  deleteRow(row: MateriaInterface) {
    this.tableMateriasToAdd.deleteRow(row);
  }
  submitForm() {
    this.errorMessage = "";
    const submitForm = this.form.onSubmit();
    if(this.dataAddMaterias.data.length == 0){
      this.errorMessage = "Debe seleccionar al menos una materia";
      return;
    }
    if (submitForm) {
      submitForm["materias"] = this.dataAddMaterias.data.map((materia) => materia.id);
      submitForm["nivel_id"] = this.nivelSelected;
      submitForm["fecha_alta"] = submitForm["fecha_alta"] ?? new Date().toISOString();
      // Solo enviar titulo_concurrente_id si tiene valor
      if (!submitForm["titulo_concurrente_id"]) {
        delete submitForm["titulo_concurrente_id"];
      }
      this.competenciaService.asignarCompetencia(submitForm, this.titulo_id).subscribe({
        next: data => {
          this.alert.goBack = false; // Evitar que el alert haga un "go back" al cerrar
          this.alert.emitEventOnClose = true; // Configurar para emitir evento al cerrar el alert
          this.alert.returnFocus = false; // Evitar que el alert intente devolver el foco a un elemento específico
          this.alert.openAlert("success", "Guardado!");
          this.fetchData({ skip: this.skip, take: this.take }, true);
          this.panelOpenState.set(false);
          this.alert.onClose.subscribe(() => {
            this.clearAllMateriasAdded();
            this.getMaterias({ skip: this.skip, take: this.take }, true);
            this.scrollToTop();
          });
        },
        error: err => {
          this.alert.openAlert("error", "Algo ocurrió")
        }
      })
    }
  }
  selectedValueFromForm(event:FieldValueEmit){
    if(event.field === 'modalidad_id'){
      this.spinner = true;
      this.modalidad_selected = event.value
      this.getMaterias({ skip: this.skip, take: this.take }, true);
    }
  }
  filtrarPorDescripcion(paginateOptions: PaginateOptions , ignoreCache: boolean = false) {
    const value = paginateOptions.globalFilterValue;
    if (value) {
      this.getMaterias({ skip: this.skip, take: this.take, globalFilterValue: value }, ignoreCache);
    } else {
      this.getMaterias({ skip: this.skip, take: this.take }, ignoreCache);
    }
  }
  openModal(event: any) {
    this.competenciaDetail = null!;
    this.templateView = false;
    this.competencia_id = event.id;
    if(event.action === 'competencia-view'){
      this.templateView = true;
      this.apiService.getById(this.competencia_id).subscribe((data) => {
        this.competenciaDetail = data as CompetenciaInterface;
      });
    }
  }
  formIsSubmit(){
    this.modalEditCompetencia.submit();
    this.modalEditCompetencia.formSubmitEvent.subscribe(() => {
      this.fetchData(this.currentPaginateOptions, true);
    });
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  get fieldsAddCompetenciasConfig() {
    return this.nivelSelected === 3
      ? this.fieldsAddCompetenciasSuperior
      : this.fieldsAddCompetencias;
  }
}
